import { throwError as observableThrowError, Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { AgendaTelefonica } from '@app/models/agenda-telefonica.model';

@Injectable()
export class AgendaTelefonicaService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(naturezaDeAcao: AgendaTelefonica): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'agenda/telefonica', naturezaDeAcao).pipe(
        catchError((error: any) => observableThrowError(error)));
  }


  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `agenda/telefonica/${id}`);
  }

  obterPorId(id: number): Observable<AgendaTelefonica> {
    return this.http
      .get<AgendaTelefonica>(this.URL_API + `agenda/telefonica/${id}`);
  }

  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'agenda/telefonica').pipe(
        map((res: Response) => res.json()));
  }

  obterPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `agenda/telefonica/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
